module.exports = __webpack_public_path__ + "img/home-hero-75a8155.jpg";